require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./1-dmgt-at-a-glance.json") })
        }
      }, "path---1-dmgt-at-a-glance");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---1-dmgt-at-a-glance!./.cache/json/1-dmgt-at-a-glance.json
// module id = 361
// module chunks = 231608221292675